export const componentsList = [
    { name: 'Button', href: '/components/button', icon: null },
    { name: 'Card', href: '/components/card', icon: null },
    { name: 'Input', href: '/components/input', icon: null },
    { name: 'Modal', href: '/components/modal', icon: null },
  ];